import React, { useEffect, useState } from 'react'
import Modal from 'components/modal'
import 'less/scheduler/unlink-moderator-availability.less'


const UnlinkModeratorAvailabilityModal = props => {
  const [timeslot, setTimeslot] = useState(props.timeSlot)

  useEffect(() => {
    if (props.timeSlot) {
      setTimeslot(props.timeSlot)
    }
  }, [props.timeSlot])

  const onSubmit = () => {
    
    props.onSubmit()
  }
  return (
    <Modal
      title={"Unlink External Availability "}
      isOpen={props.isOpen}
      className="confirmation-modal unlink-moderator-availability-modal"
      type="modal"
      autoFocusSubmit={false}
      submitBtnText="Ok"
      onCancel={props.onClose}
      isSubmitting={props.isSubmitting}
      onSubmit={() => onSubmit()}
    >
      <div className="unlink-moderator-availability-modal-body">
        <div className="unlink-moderator-availability-modal-text">
          <p>
            {props.t('import.unlink')}
          </p>
        </div>
      </div>
    </Modal>
  )
}

export default UnlinkModeratorAvailabilityModal
